import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="recurrence-fields"
export default class extends Controller {
  static targets = ["toggle", "fields"]

  connect() {
    this.update()
  }

  toggle() {
    this.update()
  }

  update() {
    if (!this.hasFieldsTarget) return

    const repeatWeeklyEnabled = this.hasToggleTarget && this.toggleTarget.checked
    this.fieldsTarget.classList.toggle("d-none", !repeatWeeklyEnabled)
    this.fieldsTarget.classList.toggle("hidden", !repeatWeeklyEnabled)
  }
}
